import * as React from "react"

/*
   Whether this viewer excludes out-of-scope marks. Off by default: the figures over every mark are
   the figures of record. Remembered per browser, so the run list, a run and its labels agree; a
   browser that refuses storage (private window, blocked site data) still gets the switch for the
   life of the page.
*/

const STORAGE_KEY = "pyxis.evalRuns.excludeOutOfScope"
const listeners = new Set<() => void>()
/** The choice for this page, used once storage has refused a write. */
let fallback: boolean | null = null

function read(): boolean {
  if (fallback !== null) return fallback
  try {
    return globalThis.localStorage.getItem(STORAGE_KEY) === "1"
  } catch {
    return false
  }
}

function write(value: boolean): void {
  try {
    if (value) globalThis.localStorage.setItem(STORAGE_KEY, "1")
    else globalThis.localStorage.removeItem(STORAGE_KEY)
  } catch {
    // Storage refused: keep the choice in memory for the life of the page.
    fallback = value
  }
  for (const listener of listeners) listener()
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function useExcludeOutOfScope(): [boolean, (value: boolean) => void] {
  const value = React.useSyncExternalStore(subscribe, read, () => false)
  return [value, write]
}
